"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_common_1 = require("../core/core-common");
var logging_1 = require("../core/logging");
$(function () {
    (0, logging_1.logScriptLoad)("[home]");
    (0, core_common_1.setupCommon)();
    if (Number($("#SiteUnavailable").val()) === 1 || $("#ShowCallbackDialog").val() === "true") {
        (0, core_common_1.showRetailerInfoDialog)();
    }
    (0, core_common_1.setNavigationStepStates)(0 /* NavStep.Vehicle */);
    generateToken();
});
function generateToken() {
    var token = Date.now().toString(36) + Math.random().toString(36).slice(2);
    $("#Token").val(token);
}
